export default __webpack_public_path__ + "static/media/co.490429cd.svg";